import { Route, Routes } from "react-router-dom";
import Booking from "./components/info/Booking";
import Delivery from "./components/info/Delivery";
import Expense from "./components/info/Expense";
import Signin from "./components/auth/Signin";
import PrivateRoute from "./components/routes/PrivateRoute";
function App() {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Booking />
            </PrivateRoute>
          }
        />
        <Route
          path="/delivery"
          element={
            <PrivateRoute>
              <Delivery />
            </PrivateRoute>
          }
        />
        <Route
          path="/expense"
          element={
            <PrivateRoute>
              <Expense />
            </PrivateRoute>
          }
        />
        <Route path="/signin" element={<Signin />} />
      </Routes>
    </>
  );
}

export default App;
